import { render, staticRenderFns } from "./NedbankPayBankForm.vue?vue&type=template&id=2c64f24b&scoped=true"
import script from "./NedbankPayBankForm.vue?vue&type=script&lang=js"
export * from "./NedbankPayBankForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c64f24b",
  null
  
)

export default component.exports